

import React, { useState } from 'react';
import moment from 'moment'

import { Table, Space } from "antd";
import DailySubTable from './DailySubTable';
import axios from 'axios';




export default function MonthlySubTable({ data, negozio, interval }) {

    const [daily, setDaily] = useState([]);
    const [loading, setLoading] = useState(false);


    const [expandedRowKeys, setExpandedRowKeys] = useState([]);


    function fetchDailyData(start_time, end_time) {
        setLoading(true)
        axios
            .get(
                `${process.env.REACT_APP_SERVER_URL}/api/dati/articles_interval/${negozio}?start=${start_time}&end=${end_time}&interval=day`
            )
            .then((response) => {
                console.log(response)
                // this.setState({ dataSource: response.data.dateFilter.buckets[0].negozi.buckets }, () => { console.log(this.state.dataSource) })
                setDaily(response.data.articoli.buckets[0].negozi.buckets[0].per_negozio.buckets)
            })
            .catch((error) => {
                // handle error
                console.log(error);
            })
            .then(() => {
                // always executed
                setLoading(false)
            });
    }


    function dailyData(expanded, record) {


        var keys = [];
        if (expanded) {
            keys.push(record.productId); // I have set my record.id as row key. Check the documentation for more details.
        }
        setExpandedRowKeys(keys)


        let start_time = moment(record.key_as_string).format("YYYY-MM-DD")
        let end_time = moment(record.key_as_string).add(1, 'M').format("YYYY-MM-DD")
        fetchDailyData(start_time, end_time)
        console.log(expanded)
        console.log(record)
    }

    const columns = [
        {
            title: interval === "year" ? 'Anno' : 'Mese',
            dataIndex: 'key_as_string',
            key: 'key_as_string',
            render: (text, row) => (
                <Space size="middle" key={row.productId}>
                    { interval === "year" ? <p>{moment(row.key_as_string).format("YYYY")}</p> : <p>{moment(row.key_as_string).format("MMMM YYYY")}</p>}
                </Space>
            ),
        },
        {
            title: 'Articoli',
            // dataIndex: 'key',
            // key: 'key',
            render: (text, row) => {
                return row.articoli.buckets.map((articolo) =>
                    <li key={articolo.productId}>{articolo.key}</li>
                );
            },
        },
        {
            title: 'ID Prodotto',
            // dataIndex: 'key',
            // key: 'productId',
            render: (text, row) => {
                return row.articoli.buckets.map((articolo) =>
                    <li key={articolo.productId}>{articolo.productId}</li>
                );
            },
        },
        {
            title: 'Quantita',
            // dataIndex: 'key',
            // key: 'quantity',
            render: (text, row) => {
                return row.articoli.buckets.map((articolo) =>
                    <li key={articolo.productId}> {articolo.quantity.toFixed(2)} </li>
                );
            },
        },
        {
            title: 'Prezzo/unita  medio',
            // dataIndex: 'key',
            // key: 'avg_unit_price',
            render: (text, row) => {
                return row.articoli.buckets.map((articolo) =>
                    <li key={articolo.productId}> {articolo.unit_price.toFixed(2)} </li>
                );
            },
        },
        {
            title: 'Totale venduto',
            // dataIndex: 'key',
            // key: 'totalSold',
            render: (text, row) => {
                return row.articoli.buckets.map((articolo) =>
                    <li key={articolo.productId}> {articolo.totalSold.toFixed(2)} </li>
                );
            },
        },
    ];
    return <Table columns={columns}
        pagination={true}
        dataSource={data} expandable={{
            expandedRowRender: record => <DailySubTable data={daily} loading={loading} columns={columns} />,
            onExpand: (expanded, record) => dailyData(expanded, record),
            rowExpandable: () => interval === 'month',
            pagination: true
        }} />;
} 
